import Box from '@zenbusiness/zui/Box';
import superstyled from '@zenbusiness/zui/styles/superstyled';
import Text from '@zenbusiness/zui/Text';

export const UserResponseRoot = superstyled({
  name: 'UserResponse',
  slot: 'Root',
  tag: Box,
  styles: ({ theme }) => ({
    marginBottom: theme.spacing(2),
    display: 'flex',
    justifyContent: 'flex-end', // Right-align user messages
    width: '100%'
  })
});

export const UserResponseBubble = superstyled({
  name: 'UserResponse',
  slot: 'Bubble',
  tag: Box,
  styles: ({ theme }) => ({
    backgroundColor: theme.palette.background.grey.dark,
    borderRadius: theme.spacing(1.5),
    padding: theme.spacing(1, 2.5),
    maxWidth: '82%', // Prevent messages from taking full width
    boxShadow: theme.shadows[1]
  })
});

export const UserResponseText = superstyled({
  name: 'UserResponse',
  slot: 'Text',
  tag: Text,
  styles: ({ theme }) => ({
    color: theme.palette.text.primary,
    whiteSpace: 'pre-wrap',
    wordBreak: 'break-word',
    // textWrap: 'pretty',
    textAlign: 'right'
  })
});
